import * as SectionIcons from '@assets/icons/sprite_icons/sensor/perim/section';
import { Icon } from '@chakra-ui/react';

import {
  AutomatonSectionStatusEnumWithMaintenance,
  ConnectorStatusEnum,
  HealthStatusEnum,
  SegmentSpecificStateEnum,
  SpecificStateEnum,
} from '@/types/sensor/sensors';

type AutomatonSegmentStateIconProps = {
  state: SegmentSpecificStateEnum | null;
  status?: AutomatonSectionStatusEnumWithMaintenance;
  size?: 'md' | 'sm';
};

const iconComponentsL = {
  undefined: SectionIcons.TroWhL,
  [ConnectorStatusEnum.UNREACHABLE]: SectionIcons.TroWhL,
  [HealthStatusEnum.NA]: SectionIcons.TroPrL,
  maintenance: SectionIcons.TroWorkOrL,
  [SpecificStateEnum.SLEEP]: SectionIcons.TroSleepGyL,
  [SpecificStateEnum.EFFRACTION]: SectionIcons.TroEffractionRdL,
  [HealthStatusEnum.DEGRADED]: SectionIcons.TroOrL,
  [HealthStatusEnum.KO]: SectionIcons.TroOrL,
  [SpecificStateEnum.HT_DETECTION]: SectionIcons.TroHtDetectionGnL,
  [SpecificStateEnum.BT_DETECTION]: SectionIcons.TroGnL,
  [HealthStatusEnum.HEALTHY]: SectionIcons.TroGnL,
};

const iconComponentsM = {
  undefined: SectionIcons.TroWhM,
  [ConnectorStatusEnum.UNREACHABLE]: SectionIcons.TroWhM,
  [HealthStatusEnum.NA]: SectionIcons.TroPrM,
  maintenance: SectionIcons.TroWorkOrM,
  [SpecificStateEnum.SLEEP]: SectionIcons.TroSleepGyM,
  [SpecificStateEnum.EFFRACTION]: SectionIcons.TroEffractionRdM,
  [HealthStatusEnum.DEGRADED]: SectionIcons.TroOrM,
  [HealthStatusEnum.KO]: SectionIcons.TroOrM,
  [SpecificStateEnum.HT_DETECTION]: SectionIcons.TroHtDetectionGnM,
  [SpecificStateEnum.BT_DETECTION]: SectionIcons.TroGnM,
  [HealthStatusEnum.HEALTHY]: SectionIcons.TroGnM,
};

export default function AutomatonSectionIcon({ status, size = 'md', state }: Readonly<AutomatonSegmentStateIconProps>) {
  function getIcon() {
    const displayedValue =
      state === SpecificStateEnum.SLEEP || state === SpecificStateEnum.EFFRACTION || status === HealthStatusEnum.HEALTHY
        ? state
        : status;
    if (size === 'md') {
      return iconComponentsL[displayedValue ?? ConnectorStatusEnum.UNREACHABLE];
    }
    return iconComponentsM[displayedValue ?? ConnectorStatusEnum.UNREACHABLE];
  }

  return <Icon as={getIcon()} height={{ base: '48px', '4k': '68px' }} />;
}
